var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3132_4867)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 10.5C21 13.2848 19.8938 15.9555 17.9246 17.9246C15.9555 19.8938 13.2848 21 10.5 21C7.71523 21 5.04451 19.8938 3.07538 17.9246C1.10625 15.9555 0 13.2848 0 10.5C0 7.71523 1.10625 5.04451 3.07538 3.07538C5.04451 1.10625 7.71523 0 10.5 0C13.2848 0 15.9555 1.10625 17.9246 3.07538C19.8938 5.04451 21 7.71523 21 10.5ZM10.8767 7.75163C9.85556 8.17688 7.81331 9.05625 4.75256 10.3897C4.25644 10.5866 3.99525 10.7809 3.97163 10.9699C3.93225 11.2888 4.33256 11.4148 4.87725 11.5868L5.10694 11.6589C5.64244 11.8335 6.36431 12.0369 6.73837 12.0448C7.07962 12.0527 7.45894 11.9136 7.87762 11.6248C10.7376 9.69413 12.2141 8.71894 12.306 8.69794C12.3716 8.68219 12.4635 8.66381 12.5239 8.71894C12.5856 8.77275 12.579 8.87644 12.5724 8.904C12.5331 9.07331 10.962 10.5328 10.1496 11.2888C9.89625 11.5251 9.71644 11.6918 9.67969 11.7298C9.59876 11.8125 9.5165 11.8939 9.43294 11.9739C8.93419 12.4543 8.56144 12.8139 9.45263 13.4019C9.88181 13.6854 10.2257 13.9177 10.5682 14.1514C10.941 14.406 11.3138 14.6593 11.7968 14.9769C11.9188 15.0557 12.0369 15.141 12.1511 15.2224C12.5856 15.5321 12.978 15.8104 13.4597 15.7657C13.7406 15.7395 14.0306 15.477 14.1776 14.6895C14.5254 12.8297 15.2093 8.80163 15.3668 7.14131C15.3764 7.00329 15.3706 6.86463 15.3497 6.72787C15.3373 6.61752 15.2839 6.51585 15.2001 6.44306C15.0806 6.36062 14.9383 6.31791 14.7932 6.321C14.3994 6.32756 13.7917 6.53888 10.8767 7.75163Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3132_4867"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegram-icon.52b864f4bd513401895f1a4574bb39e5.svg";
export { ForwardRef as ReactComponent };